import { useEffect, useState } from "react";

import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import {
  getAllDepartments,
  getDepartment,
  deleteDepartment,
} from "../../../../../action/masters/departmentActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  IDepartmentIndex,
  IDepartmentData,
} from "../../../../../models/master/department";
import { setDepartments } from "../../../../../store/slices/common/commonSlice";
import ViewDepartment from "./departmentView";
import DepartmentCreate from "./departmentCreate";
import DepartmentEdit from "./departmentEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";

const DepartmentIndex = (props: IDepartmentIndex) => {
  const {
    getDepartments,
    departments,
    getDepartment,
    department,
    deleteDepartment,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [isViewLoading, setIsViewLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);
  const handleViewOpen = () => setShowView(true);
  const handleViewClose = () => setShowView(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getDepartment(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const viewItem = async (id: number) => {
    handleViewOpen();
    setIsViewLoading(true);
    try {
      await getDepartment(id);
    } finally {
      setIsViewLoading(false);
    }
  };

  const getAllDepartments = async () => {
    setIsLoading(true);
    try {
      await getDepartments();
    } finally {
      setIsLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteDepartment(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllDepartments();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  useEffect(() => {
    getAllDepartments();
    return () => {
      dispatch(setDepartments([]));
    };
  }, []);

  return (
    <div className="admin-wrap">
      <div className="admincontent">
        <div className="title">
          <h2>Department</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : departments && departments.length > 0 ? (
            departments.length > 0 &&
            departments.map((department: IDepartmentData) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !department.isActive ? "none" : "auto",
                    opacity: !department.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-view"
                        data-bs-toggle="modal"
                        data-bs-target="#viewdepartment"
                        onClick={() => viewItem(department.id ?? 0)}
                      >
                        <img src="/assets/images/icon/eye-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-edit"
                        onClick={() => editItem(department.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(department.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <div className="btm">
                    <a
                      href="javascript:void(0)"
                      data-bs-toggle="modal"
                      data-bs-target="#viewdetails"
                    >
                      <div className="img">
                        <img
                          src={
                            department.departmentLogo
                              ? baseURL + department.departmentLogo
                              : ""
                          }
                        />
                      </div>
                    </a>
                    <h2>{department.name}</h2>
                    <p>{department.collegeName}</p>
                  </div>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>

        {isEditLoading ? (
          <LoaderSpinner />
        ) : (
          <ReactModal
            isOpen={showCreate}
            onRequestClose={handleCreateClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            shouldCloseOnOverlayClick={false}
          >
            <DepartmentCreate
              setShowCreate={handleCreateClose}
              getAllDepartments={() => getAllDepartments()}
            />
          </ReactModal>
        )}

        {isEditLoading ? (
          <LoaderSpinner />
        ) : (
          <ReactModal
            isOpen={showEdit}
            onRequestClose={handleEditClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            shouldCloseOnOverlayClick={false}
          >
            <DepartmentEdit
              setShowEdit={handleEditClose}
              getAllDepartments={() => getAllDepartments()}
              department={department}
            />
          </ReactModal>
        )}

        {isViewLoading ? (
          <LoaderSpinner />
        ) : (
          <ReactModal
            isOpen={showView}
            onRequestClose={handleViewClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            shouldCloseOnOverlayClick={false}
          >
            <ViewDepartment
              setShowView={handleViewClose}
              department={department}
            />
          </ReactModal>
        )}

        <SweetAlert
          show={showAlert}
          success={false}
          type={alertType}
          title={alertTitle}
          onConfirm={() => onConfirm()}
          showCancel={isDelete}
          onCancel={() => {
            setShowAlert(false);
            setIsDelete(false);
          }}
          cancelBtnText={"No"}
          confirmBtnText={isDelete ? "Yes" : "Ok"}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getDepartments: () => getAllDepartments(),
  getDepartment: (id: number) => getDepartment(id),
  deleteDepartment: (id: number, callBack: Function) =>
    deleteDepartment(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    departments: state.department.departments,
    department: state.department.department,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentIndex);
